module.exports = __webpack_public_path__ + "static/media/facebookLogo.4cc9fd84.png";